import logo from './logo.svg';
import './App.css';
import Operators from './Componentns/Operators';

function App() {
  return (
    <div className="App">
      <Operators></Operators>
    </div>
  );
}

export default App;
